export default "__VITE_ASSET__DBGd5OtG__"